export const lmExclusions = [
  'blackfriday2020'
];
